var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M254 1H0.999995","stroke":"#EEEEEE","strokeLinecap":"round","strokeDasharray":"5 5"}));
}

Line.defaultProps = {"width":"100%","height":"2","viewBox":"0 0 100 2","fill":"none"};

module.exports = Line;

Line.default = Line;
